import Tools from './tools';

export default class Nav {
    constructor() {
    	this.tools = new Tools();
    	this.header();
        this.burger();
        if(window.innerWidth > 1023) {
            this.footer();
        }
    }

    header() {
    	const regex = /\#(.*)/gm;

    	const links = document.querySelectorAll('nav ul li');
    	Array.from(links).forEach( link => {
    		link.addEventListener('click', e => {
                if (!link.classList.contains('instagram')) {
                    e.preventDefault();
                    
                    let offset = 0;

                    if (link.classList.contains('logo') || link.classList.contains('top')) {
                        this.scrollTo(0);
                    } else {
                        let hash = link.querySelector('a').href,
                            id = hash.match(regex)[0];

                        if(id != '#acces') {
                            offset = this.tools.offset(document.querySelector(id)).top - document.querySelector('nav').offsetHeight;
                        } else {
                            offset = document.body.offsetHeight;
                        }
                        this.scrollTo(offset);
                    }

                    if (window.innerWidth < 1024) {
                        document.querySelector('nav').classList.remove('open');
                    }
                }
    		});
    	} );
    }

    burger() {
        const burgerBtn = document.querySelector('nav .burger');
        if (burgerBtn) {
            burgerBtn.addEventListener('click', function(){
                document.querySelector('nav').classList.toggle('open');
            });
        }
    }

    footer() {
        const footerHeight = document.querySelector('footer').offsetHeight;
        document.body.style.marginBottom = footerHeight + 'px';
    }

    scrollTo(val) {
    	const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    	if (supportsNativeSmoothScroll) {
            window.scrollTo({
                top: val,
                left: 0,
                behavior: 'smooth',
            });
        } else {
            window.scrollTo(val, 0);
        }
    }
}